/**
 * /trouve/chat — Dedicated full-page Trouvé chat.
 *
 * Same TrouveChatPanel under the hood as the AR-mirror overlay, just
 * laid out as a full screen experience. Reachable from:
 *   • Header avatar dropdown "Ask Trouvé"
 *   • /my-trouve-chats "New chat" CTA
 *   • Direct link
 */
import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, FileText } from "lucide-react";
import Header from "../components/Header";
import TrouveChatPanel from "../components/TrouveChatPanel";

const TrouveChat = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-[#FDFBF7] flex flex-col">
      <Header />
      <div className="flex-1 flex flex-col max-w-3xl w-full mx-auto px-4 sm:px-6 py-4 sm:py-6">
        <div className="flex items-center justify-between mb-4">
          <button
            type="button"
            onClick={() => navigate(-1)}
            className="inline-flex items-center gap-1 text-sm text-[#5C4B51] hover:text-[#9B6A6C]"
            data-testid="trouve-page-back"
          >
            <ArrowLeft className="h-4 w-4" />
            {t("common.back")}
          </button>
          <button
            type="button"
            onClick={() => navigate("/my-trouve-chats")}
            className="inline-flex items-center gap-1.5 text-sm text-[#5C4B51] hover:text-[#9B6A6C]"
            data-testid="trouve-page-saved-chats"
          >
            <FileText className="h-4 w-4" />
            {t("trouveChat.savedChats")}
          </button>
        </div>
        <div className="flex-1 min-h-[600px] bg-white rounded-2xl border border-[#EADDD7] overflow-hidden">
          <TrouveChatPanel dataTestidPrefix="trouve-page-chat" />
        </div>
      </div>
    </div>
  );
};

export default TrouveChat;
